import { render, staticRenderFns } from "./TruformeLabReq.vue?vue&type=template&id=1ccc8770&scoped=true"
import script from "./TruformeLabReq.vue?vue&type=script&lang=js"
export * from "./TruformeLabReq.vue?vue&type=script&lang=js"
import style0 from "./TruformeLabReq.vue?vue&type=style&index=0&id=1ccc8770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccc8770",
  null
  
)

export default component.exports